import React from "react";
import {
  Grid,
  CardContent,
  CardHeader,
  Card,
  Divider,
} from "@material-ui/core";
import QuarterlyTradesReportTable from "./QuarterlyTradesReportTable";
import { usePageStyles } from "../../../pageStyles";
import { PageComponent } from "../../../../core/navigation/types";
import { PageTitle } from "../../../components/common/PageTitle";
import { QuarterlyTradesReportFilter } from "./QuarterlyTradesReportFilter";
import { DownloadButton, DownloadExcelButton } from "./DownloadButton";

const QuarterlyTradesReport: PageComponent = ({ userAccessRights }) => {
  const pageStyles = usePageStyles();

  return (
    <>
      <Grid container className={pageStyles.root}>
        <Grid item xs={12} className={pageStyles.gridItem}>
          <Card>
            <CardHeader
              title={<PageTitle title="secCommQuarterlyTradeReportTitle" />}
              action={<QuarterlyTradesReportActions />}
            />
            <Divider />
            <CardContent>
              <QuarterlyTradesReportTable userAccessRights={userAccessRights} />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
};

export const QuarterlyTradesReportActions: React.FunctionComponent = () => (
  <Grid container>
    <Grid item>
      <QuarterlyTradesReportFilter />
    </Grid>
    <Grid item>
      <DownloadButton />
    </Grid>
    <Grid item>
      <DownloadExcelButton />
    </Grid>
  </Grid>
);

export default QuarterlyTradesReport;
